import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'client';

import { requestSchemasByIds } from '@atom/actions/inventorySchemaActions';
import { Progress } from '@atom/mui';
import { getHydratedInventorySchemaByIds } from '@atom/selectors/inventorySchemasSelectors';
import { AssetSchemaType, AttributeGroupItem } from '@atom/types/form';
import { AttributesType } from '@atom/types/inventory';
import { SchemaType } from '@atom/types/schema';

import AssetField from './AssetField';

import '../formBuilder.css';

interface Props {
  fieldId: string;
  rootSchema: SchemaType;
  assetSchemas: AssetSchemaType[];
  updateAttributeGroup: (
    fieldId: string,
    schemaId: string,
    addGroup: boolean,
    attributeGroup: AttributeGroupItem,
  ) => void;
  updateAttribute: (
    fieldId: string,
    schemaId: string,
    addAttribute: boolean,
    attributeGroupName: string,
    attribute: AttributesType,
  ) => void;
  addAllAttributes: (
    fieldId: string,
    schemaId: string,
    attributeGroupName: string,
    attributes: AttributesType[],
  ) => void;
  removeAssetSchema: (fieldId: string, schemaId: string) => void;
}

const AssetBlock = ({
  assetSchemas,
  fieldId,
  rootSchema,
  updateAttributeGroup,
  updateAttribute,
  addAllAttributes,
  removeAssetSchema,
}: Props) => {
  const dispatch = useDispatch();
  const inventorySchemasByIds = useSelector((state: RootState) =>
    getHydratedInventorySchemaByIds(state),
  );
  const loading = useSelector(
    (state: RootState) => state.loading.loadingInventorySchemasByIds,
  );

  useEffect(() => {
    if (rootSchema.id) {
      dispatch(
        requestSchemasByIds({
          parentSchemaId: rootSchema.id,
          fieldId,
          isPublished: 'true,false',
        }),
      );
    }
  }, [rootSchema.id]);

  const content = loading ? (
    <Progress />
  ) : (
    assetSchemas.map((assetSchema: AssetSchemaType) => {
      const fullSchema = inventorySchemasByIds[fieldId]
        ? inventorySchemasByIds[fieldId].find(
            (inventorySchema: SchemaType): boolean =>
              inventorySchema.id === assetSchema.id,
          )
        : { attributeGroups: [] };

      return (
        <AssetField
          rootSchema={rootSchema}
          key={assetSchema.id}
          // @ts-ignore
          fullSchema={fullSchema}
          assetSchema={assetSchema}
          fieldId={fieldId}
          updateAttributeGroup={updateAttributeGroup}
          updateAttribute={updateAttribute}
          addAllAttributes={addAllAttributes}
          removeAssetSchema={removeAssetSchema}
        />
      );
    })
  );

  return <>{content}</>;
};

export default AssetBlock;
